import { defineStore } from 'pinia'

import type { OrdersStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useOrdersStore = defineStore('orders', {
  state: (): OrdersStore => ({
    loading: false,
    orders: [],
    meta: null,
    filterSearch: null,
    filterStatuses: [],
    filterType: null,
    filterFrom: null,
    filterTo: null,
    filterLessonsFrom: null,
    filterLessonsTo: null,
    filterPromocodeId: null,
    filterCustomerId: null,
    currentPage: 1,
    perPage: 25,
  }),
  actions,
  getters,
})
